import { ComponentType } from 'react';
import { AttachmentType, TAttachment } from '@/models/chat.model';
import VideoAttachment from '../components/VideoAttachment/VideoAttachment';
import { isSafeMediaUrl } from './url';

export type TAttachmentRendererProps = {
  attachment: TAttachment;
};

export type TAttachmentRenderer = ComponentType<TAttachmentRendererProps>;

export const ATTACHMENT_RENDERERS: Partial<Record<AttachmentType, TAttachmentRenderer>> = {
  [AttachmentType.VIDEO]: VideoAttachment,
};

export const getAttachmentRenderer = (attachment?: TAttachment): TAttachmentRenderer | undefined => {
  if (!attachment || !isSafeMediaUrl(attachment.url)) return undefined;

  return ATTACHMENT_RENDERERS[attachment.type];
};
